
// Import css files
import { Link } from "react-router-dom";
import bulb from '../../../../../assets/images/bulbbanking.png';
import TextWithBreaks from "../../../../../shared/lineBreak";
import expiryclock from '../../../../../assets/images/expiryclock.svg';
import blogheadicon from '../../../../../assets/images/blogheadicon.svg';
import bankingicon from '../../../../../assets/askTheExpertImages/bankingmenuicon.svg';
import question from '../../../../../assets/images/askiconbl.png';
import askimg from "../../../../../assets/homeimages/askbtn.svg";
import React, { useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../../shared/helper";

const BankingArticleDetailsV2Jsx = (props) => {
  const {
    detailsData
  } = props;
  const { t } = useTranslation();
  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])
  return (
    <>

<section className="bankinversiononedetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectiooneleft">
                  <div className="tagreal"><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
                  <div className="blogsectioleft">
                    <div className="title">
                      <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
                      <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_2?.banner_sectionn.short_description }}></div>
                    
                  </div></div>
                <div className="anptag">
                  <p>{detailsData?.acf?.variant_2?.banner_sectionn.description}</p>
                  <div className="d-flex align-items-center justify-content-between pb-4 d-block d-lg-none d-sm-none d-md-none sm-flex">
            <p className="articlepublishdate mt-2"><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
                  <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  
                   </div> 
                  
                   </div>
                  </div>
               
              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectioright">
                  <img src={detailsData?.acf?.variant_2?.banner_sectionn?.image} alt="bannermage" />
                
                </div>
              
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between pb-4 ">
            <p className="articlepublishdate mt-2"><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
                  <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  
                   </div> 
                  
                   </div>
          </div>
          <div className="blogsectiotwo">
            <div className="blogsectiotwoinner">
              <h2>{detailsData?.acf?.variant_2?.overview_section.title}</h2>
              <p>
              {detailsData?.acf?.variant_2?.overview_section.description}
              </p>
              {detailsData?.acf?.variant_2?.overview_section.tagline}
            </div>
          </div>
          <div className="blogsectiothree">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="d-flex">
              <div className="blogsectiothreelefttop"><h2>Each detail carries your destiny!</h2></div>
              <div className="blogsectiotimage"><img src={detailsData?.acf?.variant_2?.overview_section_2.image} alt="blogimage" /></div>
              </div>
                <div className="blogsectiothreeleft">
                  <h2>{detailsData?.acf?.variant_2?.overview_section_2.title}</h2>
                  <p><TextWithBreaks text={detailsData?.acf?.variant_2?.overview_section_2.description} /></p>

                </div>
              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectiothreeright">
                  <h2>{detailsData?.acf?.variant_2?.overview_section_2.title_2}</h2>
                  <ul>
                  {detailsData?.acf?.variant_2?.overview_section_2.criteria.map((item,index) => (                  
                    <li>
                      <span>{String.fromCharCode(65 + index)}</span>
                      <p>{item?.item} </p>
                    </li>
                  ))}
                   
                  </ul>
                </div>
              </div>
            </div>
           
          </div>
          <div className="blogsectiofour">
            <h2>{detailsData?.acf?.variant_2?.benefits_section.title}  </h2>
            <p>{detailsData?.acf?.variant_2?.benefits_section.short_description} </p>
            <div className="row">
            {detailsData?.acf?.variant_2?.benefits_section.benefits.map((item,index)=>(
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">{ String(index+1).padStart(2, '0')}</div>
                  <h4>{item?.title}</h4>
                  <p>{item?.description}</p>
                </div>
              </div>
              ))}
              
              
              

            </div>

          </div>
          <div className="blogsectiofive">
            <div className="row">

              <div className="col-lg-9 col-sm-9">
                <h2> {detailsData?.acf?.variant_2?.offer_section?.title}</h2>
                <p>{detailsData?.acf?.variant_2?.offer_section?.sub_title}</p>
                <div className="blogsectiofivemiddle">
                  <div className="blogsectiofivemiddleinner">
                    <ul>
                    {detailsData?.acf?.variant_2?.offer_section.step.map((item,index)=>(
                      <li>
                        <img src={blogheadicon} alt="blogimage" />
                        <h3>Step {index}</h3>
                        <h4>{item?.heading}</h4>
                        <p>{item?.description}</p>
                      </li>
                      ))}

                     
                    </ul>

                  </div>

                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <div className="blogsectiofiveright">
                  <div className="bulb">
                    <img src={bulb} alt="bulb" />
                  </div>
                  <h2>{detailsData?.acf?.variant_2?.conclusion_section.title}</h2>
                  <div>
                    {detailsData?.acf?.variant_2?.conclusion_section.description_points.map((item,index) => (  
                        <p>{item?.point} </p>
                    ))}
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_2?.conclusion_section.description }}></div>                  
                  <Link to={detailsData?.acf?.variant_2?.conclusion_section.apply_url} className="applynow">{detailsData?.acf?.variant_2?.conclusion_section?.button_text}</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsixsection">
            <div className="d-flex blogsixsectioninner align-items-center">
              <div className="col-lg-1 col-sm-1"><img src={question} alt="blogicon" /></div>
              <div className="blogsixsectioninnerbtn">
                <Link to={'/AskTheExpert'}>
                  <div className={`askbutton`}>
                    <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                    <img src={askimg} alt="Ask now" />
                  </div>
                </Link>
              </div>
              <div className="col-lg-6 col-sm-6">
             
              <p><Trans i18nKey={t("COMMON.BLOGV2TEXT")}></Trans></p>
              </div>
             
            </div>
          </div>
          <div className="blogdisclaimer">
       <div className="disclaimerinner">
         <h2>{t("COMMON.Disclaimer_heading")}</h2>
         <p>{t("COMMON.Disclaimer_text")}</p>
       </div>
       </div>
        </div>
      </section>
      

    </>

  );
};

export default BankingArticleDetailsV2Jsx;